import React from 'react'
import { useState, useRef, useEffect } from 'react';
// import Tudu from './components/Tudu';
import TuduList from './components/TuduList';
import { v4 as uuidv4 } from 'uuid'

const LOCAL_STORAGE_KEY = 'tuduApp.tudus'

const App = () => {

  const [ tudus, setTudus ] = useState([]);
  const tuduNameRef = useRef();

  // on page load, check localStorage for stored data. since we pass an empty array 
  // which never changes, this will never load past the first time on page load/refresh
  useEffect(() => {

    const storedTudus = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))
    
    if (storedTudus) setTudus(storedTudus)

  }, [])

  // anytime anything within the tudus array changes, call the useEffect
  useEffect(() => {

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(tudus))

  }, [tudus])

  // call addTuduHandler via pressing "enter" key
  useEffect(() => {

    const keyDownHandler = event => {

      console.log('User pressed: ', event.key);

      if (event.key === 'Enter') {

        event.preventDefault();

        addTuduHandler();

      }

    }

    document.addEventListener('keydown', keyDownHandler);

    return () => {

      document.removeEventListener('keydown', keyDownHandler);

    };

  }, []);


  const toggleTudu = (id) => {

    const newTudus = [...tudus]
    const tudu = newTudus.find(tudu => tudu.id === id)

    tudu.completed = !tudu.completed

    setTudus(newTudus)

  };

  const addTuduHandler = () => {

    const name = tuduNameRef.current.value

    if (name === '') return

    setTudus(previousTudus => {

      return [

        ...previousTudus,

        {

          id: uuidv4(),
          name: name,
          completed: false,

        }
      
      ]})

    tuduNameRef.current.value = null

  };

  const clearTuduHandler = () => {

    const newTudus = tudus.filter(tudu => !tudu.completed)
    
    setTudus(newTudus)

  };

  return (

    <>

      <div className="title"><span style={{color: '#315811'}}>tu</span><span style={{color: '#9AAD85'}}>du</span></div>

      <div className="input--div">

        <input className="inputbox" ref={ tuduNameRef } input type="text" />

      </div>

        <div className="tudu--buttons">

          <button className="btn--add" onClick={ addTuduHandler }>+ du</button>
          <button className="btn--clear" onClick={ clearTuduHandler }>- dun</button>

        </div>

      <div className="main--card">

        <TuduList tudus={ tudus } toggleTudu={ toggleTudu } />
      
      </div>

    </>

  );

};

export default App;
